import { types } from "../constants/types";

const initialState = {

    getLogin : [],
    getLoginFailed : '',

    getSignup: [],
    getSignupFailed: '',    

    checkAuth: [],
    checkAuthFailed: '',

    getAccountProfile: [],
    getAccountProfileFailed: '',

    updateAccountProfile: [],
    updateAccountProfileFailed: '',

    createCustomer : [],
    createCustomerFailed : '',

    getCustomer : [],
    getCustomerFailed : '',

    getAllCustomer : [],
    getAllCustomerFailed : '',

    updateCustomer : [],
    updateCustomerFailed : '',

    deleteCustomer: [],
    deleteCustomerFailed: '',

    getProfileWithUser: [],
    getProfileWithUserFailed: '',

    changePassword: [],
    changePasswordFailed: '',

    getWhatsappSettings: [],
    getWhatsappSettingsFailed: '',

    updateWhatsappSettings: [],
    updateWhatsappSettingsFailed: '',

    getPaymentSettings: [],
    getPaymentSettingsFailed: '',

    updatePaymentSettings: [],
    updatePaymentSettingsFailed: '',

    profile: null,
    error: null,
    notFound: false,


    
}

//receives the current state and an action object
export function userReducer(state = initialState, action) {
    switch (action.type) {
        case types.GET_LOGIN_SUCCESS:
            return {
                ...state,
                getLogin : action.payload
            }
        case types.GET_LOGIN_FAILED:
            return {
                ...state,
                getLoginFailed : action.payload
            }

        case types.GET_SIGNUP_SUCCESS:
            return {
                ...state,
                getSignup : action.payload
            }
        case types.GET_SIGNUP_FAILED:
            return {
                ...state,
                getSignupFailed : action.payload
            }
        case types.CHECK_AUTH_SUCCESS:
            return {
                ...state,
                checkAuth : action.payload
            }
        case types.CHECK_AUTH_FAILED:
            return {
                ...state,
                checkAuthFailed : action.payload
            }
        case types.GET_ACCOUNT_PROFILE_SUCCESS:
            return {
                ...state,
                getAccountProfile : action.payload
            }
        case types.GET_ACCOUNT_PROFILE_FAILED:
            return {
                ...state,
                getAccountProfileFailed : action.payload
            }
        case types.UPDATE_ACCOUNT_PROFILE_SUCCESS:
            return {
                ...state,
                updateAccountProfile : action.payload
            }
        case types.UPDATE_ACCOUNT_PROFILE_FAILED:
            return {
                ...state,
                updateAccountProfileFailed : action.payload
            }
        case types.CREATE_CUSTOMER_SUCCESS:
            return {
                ...state,
                createCustomer : action.payload
            }
        case types.CREATE_CUSTOMER_FAILED:
            return {
                ...state,
                createCustomerFailed : action.payload
            }
        case types.GET_CUSTOMER_SUCCESS:
            return {
                ...state,
                getCustomer : action.payload
            }
        case types.GET_CUSTOMER_FAILED:
            return {
                ...state,
                getCustomerFailed : action.payload
            }
        case types.GET_ALL_CUSTOMER_SUCCESS:
            return {
                ...state,
                getAllCustomer : action.payload
            }
        case types.GET_ALL_CUSTOMER_FAILED:
            return {
                ...state,
                getAllCustomerFailed : action.payload
            }    
        case types.UPDATE_CUSTOMER_SUCCESS:
            return {
                ...state,
                updateCustomer : action.payload,
                successAlert: true,
            }
        case types.UPDATE_CUSTOMER_FAILED:
            return {
                ...state,
                updateCustomerFailed : action.payload
            }
        case types.DELETE_CUSTOMER_SUCCESS:
            return {
                ...state,
                deleteCustomer : action.payload
            }
        case types.DELETE_CUSTOMER_FAILED:
            return {
                ...state,
                deleteCustomerFailed : action.payload
            }
        case types.GET_PROFILE_WITH_USER_SUCCESS:
            return {
                ...state,
                getProfileWithUser : action.payload
            }
        case types.GET_PROFILE_WITH_USER_FAILED:
            return {
                ...state,
                getProfileWithUserFailed : action.payload
            }  
        case types.GET_WHATSAPP_SETTINGS_SUCCESS:
            return {
                ...state,
                getWhatsappSettings : action.payload
            }
        case types.GET_WHATSAPP_SETTINGS_FAILED:
            return {
                ...state,
                getWhatsappSettingsFailed : action.payload
            }
        case types.UPDATE_WHATSAPP_SETTINGS_SUCCESS:
            return {
                ...state,
                updateWhatsappSettings : action.payload
            }
        case types.UPDATE_WHATSAPP_SETTINGS_FAILED:
            return {
                ...state,
                updateWhatsappSettingsFailed : action.payload
            }
        case types.GET_PAYMENT_SETTINGS_SUCCESS:
            return {
                ...state,
                getPaymentSettings : action.payload
            }
        case types.GET_PAYMENT_SETTINGS_FAILED:
            return {
                ...state,
                getPaymentSettingsFailed : action.payload
            }
        case types.UPDATE_PAYMENT_SETTINGS_SUCCESS:
            return {
                ...state,
                updatePaymentSettings : action.payload
            }
        case types.UPDATE_PAYMENT_SETTINGS_FAILED:
            return {
                ...state,
                updatePaymentSettingsFailed : action.payload
            } 
        case types.GET_PROFILE_WITH_USER_NOT_FOUND:
            return { ...state, profile: null, notFound: true }
        case types.RESET_SUCCESS_ALERT:
            return {
                ...state,
                successAlert: false,
            }  
        case types.CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                changePassword : action.payload
            }
        case types.CHANGE_PASSWORD_FAILED:
            return {
                ...state,
                changePasswordFailed : action.payload
            }
        default:
            return state
    }
}